import Tryout from "@/modules/tryout/components/Tryout";
import TryoutForm from "@/modules/tryout/components/Form";
import SubtestForm from "@/modules/tryout/components/SubtestForm";

export default [
    {
        path: "/tryouts",
        name: "Tryout",
        component: Tryout,
    },
    {
        path: "/tryout-form",
        name: "TryoutForm",
        component: TryoutForm,
    },
    {
        path: "/subtest-form",
        name: "SubtestForm",
        component: SubtestForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/tryout/router/tryout.js